export default __webpack_public_path__ + "media/color/bcio-7370f484.svg";